import { render, staticRenderFns } from "./type-editor.vue?vue&type=template&id=09c8e5da&scoped=true"
import script from "./type-editor.vue?vue&type=script&lang=js"
export * from "./type-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8e5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c8e5da')) {
      api.createRecord('09c8e5da', component.options)
    } else {
      api.reload('09c8e5da', component.options)
    }
    module.hot.accept("./type-editor.vue?vue&type=template&id=09c8e5da&scoped=true", function () {
      api.rerender('09c8e5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/type-editor.vue"
export default component.exports